import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { token } from '../api.js';
import { useAuth } from '../auth.jsx';

/**
 * Lands here after OAuth: the Worker redirected to /auth/callback#token=<jwt>.
 * Pull the token out of the fragment, store it, hydrate the user, go home.
 */
export default function AuthCallback() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const t = hash.get('token');
    if (!t) { setFailed(true); return; }

    token.set(t);
    // Strip the token from the URL bar before navigating on.
    window.history.replaceState(null, '', '/auth/callback');
    refresh().then((user) => {
      nav(user ? '/' : '/login', { replace: true });
    });
  }, [refresh, nav]);

  if (failed) {
    return (
      <div className="h-full flex items-center justify-center" style={{ background: 'var(--bg)', color: 'var(--red)' }}>
        Sign-in failed — no token received.{' '}
        <a href="/login" style={{ color: 'var(--primary)', marginLeft: 6 }}>Try again</a>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center gap-2" style={{ background: 'var(--bg)', color: 'var(--text-muted)' }}>
      <Loader2 size={18} className="spin" /> Signing you in…
    </div>
  );
}
